import { isProdSupervisorTeamScoped } from './roleChecks';

/**
 * Equipos visibles según rol, fábrica y empleado líder.
 *
 * @param {Array} teams
 * @param {{ factoryId?: number | null, roleKeys?: Set<string>, leaderEmployeeId?: number | null }} scope
 * @returns {Array}
 */
export function filterTeamsByRole(teams, { factoryId, roleKeys, leaderEmployeeId }) {
  let list = Array.isArray(teams) ? teams : [];
  if (factoryId) {
    list = list.filter((t) => Number(t.factory_id) === Number(factoryId));
  }
  if (isProdSupervisorTeamScoped(roleKeys) && leaderEmployeeId) {
    list = list.filter((t) => Number(t.leader_id) === Number(leaderEmployeeId));
  }
  return list;
}

/**
 * IDs de empleados de un equipo: líder + miembros activos.
 *
 * @param {object | null | undefined} team
 * @param {Array} members
 * @returns {Set<number>}
 */
export function collectTeamEmployeeIds(team, members = []) {
  const employeeIds = new Set();
  if (team?.leader_id) employeeIds.add(Number(team.leader_id));
  members.forEach((m) => {
    const eid = m.employee_id ?? m.employee?.id ?? m.Employee?.id;
    if (eid) employeeIds.add(Number(eid));
  });
  return employeeIds;
}

/**
 * Filtro de empleados para tablas de asistencia/ausencias por equipo.
 *
 * @param {object | null | undefined} team
 * @param {Array} members
 * @param {{ loading?: boolean }} [opts]
 * @returns {{ teamId: string | number, name: string, employeeIds: Set<number>, loading: boolean } | null}
 */
export function buildTeamEmployeeFilter(team, members = [], { loading = false } = {}) {
  if (!team?.id) return null;
  return {
    teamId: team.id,
    name: team.name || `Equipo ${team.id}`,
    employeeIds: collectTeamEmployeeIds(team, members),
    loading,
  };
}
